import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { SubscriptionInfo } from "./products.jsx";
import { useSelector, useDispatch } from "react-redux";
import { parse as parseQueryString } from "query-string";
import { addToCart } from "../redux/action/Get";
import {
  setHeaderActiveSignInAsSignUp,
  setHeaderActiveSignInAsSignInAs,
} from "../redux/action/header";
import {
  productNameForInventoryItem,
  productImageForInventoryItem,
  productPriceFromattedForInventoryItem,
  productMaxQuantityForInventoryItem,
  productPriceForInventoryItem,
  productUnitForInventoryItem,
  isSubscriptionItem,
  subscriptionParameterFields,
} from "../utils/inventory";

const debug = require("debug")("FarmProductCard");
const noop = () => {};

export const InventoryProductCard = (props) => {
  const { inventoryItem, userType, farmId } = props;

  const cartListDetails = useSelector((state) => {
    return state.cartList.cartListDetails;
  });

  const dispatch = useDispatch();

  const [modalDetailsShow, setModalDetailsShow] = useState(false);
  const [modalMaximumQuantityShow, setModalMaximumQuantityShow] =
    useState(false);
  const [modalMustSignInShow, setModalMustSignInShow] = useState(false);
  const [productMaxQuantity, setProductMaxQuantity] = useState(
    productMaxQuantityForInventoryItem({ inventoryItem, userType }),
  );

  let currentProductListEntry = {};
  if (Array.isArray(cartListDetails.buyList)) {
    const currentProductListEntries = cartListDetails.buyList
      ?.map((buyListEntry) => {
        return buyListEntry.productList.filter((productListEntry) => {
          return productListEntry.productId === inventoryItem._id;
        });
      })
      .reduce((accumulator, nested) => {
        return accumulator.concat(nested);
      }, []);
    if (currentProductListEntries.length === 1) {
      currentProductListEntry = currentProductListEntries[0];
    }
  }
  const productInCart =
    typeof currentProductListEntry._id === "string" &&
    currentProductListEntry._id.length > 0;

  const [productQuantity, setProductQuantity] = useState(
    currentProductListEntry.productQuantity
      ? currentProductListEntry.productQuantity
      : 1,
  );
  const prouctQuantityOnChange = (event) => {
    let quantity = +event.target.value;
    if (isNaN(quantity)) return;
    if (quantity > productMaxQuantity) {
      setModalMaximumQuantityShow(true);
    } else {
      setProductQuantity(quantity);
    }
  };

  const addToCartOnClick = (event) => {
    if (!localStorage.getItem("accessToken")) {
      setModalMustSignInShow(true);
      return;
    }
    const payload = {
      productQuantity,
      productPrice: productPriceForInventoryItem({ inventoryItem, userType }),
      productId: inventoryItem._id,
      farmId,
      unit: productUnitForInventoryItem({ inventoryItem, userType }),
      variety: inventoryItem.variety,
      distributionTypes: inventoryItem.distributionTypes,
    };
    if (isSubscriptionItem({ inventoryItem })) {
      const subscriptionParams = subscriptionParameterFields({ inventoryItem });
      Object.assign(payload, subscriptionParams);
    }
    dispatch(addToCart(payload));
  };

  /* state from query parameters */
  const queryParams = parseQueryString(window.location.search);
  let showTestProduct = false;
  // hide test products unless ?showTestProduct=true
  if (queryParams.showTestProduct) {
    showTestProduct = true;
  }
  // early null exit if we are not showing test products, and this is a test product
  if (
    productNameForInventoryItem({ inventoryItem })
      .toLowerCase()
      .startsWith("test product") &&
    showTestProduct === false
  ) {
    return null;
  }

  return (
    <>
      <div className="hp-card-col slide hp-card-col-product">
        <div className="hp-card hp-card-product">
          <div className="hp-card-background"></div>
          <div
            className="hp-card-header"
            style={{
              backgroundImage: `url(${productImageForInventoryItem({
                inventoryItem,
              })})`,
            }}
            onClick={() => setModalDetailsShow(true)}
          ></div>
          <div className="hp-card-body">
            <hgroup className="hp-card-heading-group">
              <h2 className="hp-card-heading hp-card-product-name">
                {productNameForInventoryItem({ inventoryItem })}
              </h2>
              <h3 className="hp-card-subheading hp-card-product-variety">
                {inventoryItem.variety}
              </h3>
            </hgroup>
            <div className="hp-card-body-details">
              <div className="row align-items-center hp-card-product-details-row">
                <div className="col-7">
                  <p className="product-details-price">
                    {productPriceFromattedForInventoryItem({
                      inventoryItem,
                      userType,
                    })}
                  </p>
                </div>
                <div className="col-5">
                  {productMaxQuantity > 0 && (
                    <input
                      type="number"
                      name={`qty_${inventoryItem._id}`}
                      min="1"
                      max={productMaxQuantity}
                      placeholder="1"
                      value={productQuantity}
                      className="form-control"
                      onChange={prouctQuantityOnChange}
                    />
                  )}
                </div>
              </div>
              <div className="row hidden">
                <div className="col-6">
                  <h6 className="hp-card-label"></h6>
                </div>
                <div className="col-6">
                  <h6 className="hp-card-label righted">Quantity</h6>
                </div>
              </div>
            </div>
            <SubscriptionInfo inventoryItem={inventoryItem} />
            {productMaxQuantity < 1 && (
              <h4 className="hp-card-product-out-of-stock">Out of stock</h4>
            )}
          </div>
          <div className="hp-card-link floating">
            {productMaxQuantity >= 1 && (
              <Button
                variant="info"
                disabled={productInCart}
                onClick={addToCartOnClick}
              >
                {productInCart ? "Added to cart" : "Add to cart"}
              </Button>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={modalDetailsShow}
        onHide={() => setModalDetailsShow(false)}
        className="cm_confirmation imageView"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={productImageForInventoryItem({ inventoryItem })}
              alt=" "
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 className="product-name">
            {productNameForInventoryItem({ inventoryItem })}
          </h6>

          <h6 className="product-variety">{inventoryItem.variety}</h6>
          <div className="price">
            Price{" "}
            {productPriceFromattedForInventoryItem({ inventoryItem, userType })}
          </div>

          <p>{inventoryItem.description}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setModalDetailsShow(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={modalMaximumQuantityShow}
        onHide={() => setModalMaximumQuantityShow(false)}
        className="cm_confirmation imageView"
      >
        <Modal.Header closeButton>
          <Modal.Title>Only {productMaxQuantity} units left</Modal.Title>
        </Modal.Header>
      </Modal>
      <Modal
        show={modalMustSignInShow}
        onHide={() => setModalMustSignInShow(false)}
        className="cm_confirmation imageView"
      >
        <Modal.Header closeButton>
          <Modal.Title>You are not Signed In</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>
            Please{" "}
            <span
              className="link"
              onClick={() => {
                setModalMustSignInShow(false);
                dispatch(setHeaderActiveSignInAsSignInAs());
              }}
            >
              {" "}
              Sign In
            </span>{" "}
            to your account.
            <div>
              Don't have an account?{" "}
              <span
                className="link"
                onClick={() => {
                  setModalMustSignInShow(false);
                  dispatch(setHeaderActiveSignInAsSignUp());
                }}
              >
                {" "}
                Sign Up{" "}
              </span>
            </div>
          </h6>
        </Modal.Body>
      </Modal>
    </>
  );
};
